<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="listQuery.name" placeholder="请输入提单号" style="width: 200px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="listQuery.name"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <!-- 弹窗层编辑 -->
      <el-button v-auth="'Animal.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">新增</el-button>
      <el-button v-auth="'Animal.delete'" class="action-item" type="success" icon="el-icon-view" @click="BatchDelete">核验</el-button>
      <el-button v-auth="'Animal.delete'" class="action-item" type="danger" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
      <el-button v-auth="'Animal.delete'" class="action-item" type="warning" icon="el-icon-upload2" @click="BatchDelete">导入</el-button>
      <el-button v-auth="'Animal.delete'" class="action-item" type="info" icon="el-icon-download" @click="BatchDelete">下载模版</el-button>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column align="center" type="selection"></el-table-column>
      <el-table-column align="center" type="index" width="50" label="序号 "></el-table-column>
      <el-table-column align="center" prop="name" label="提单号 "> </el-table-column>
      <el-table-column align="center" prop="unit" label="导入时间 "> </el-table-column>
      <el-table-column align="center" prop="order_no" label="用户数量 "> </el-table-column>
      <el-table-column align="center" prop="create_time" label="已核验 "> </el-table-column>
      <el-table-column align="center" prop="creator_name" label="未核验 "> </el-table-column>
      <el-table-column align="center" prop="creator_name" label="一致数 "> </el-table-column>
      <el-table-column align="center" prop="creator_name" label="不一致数 "> </el-table-column>
      <el-table-column align="center" prop="creator_name" label="计费次数 "> </el-table-column>
      <el-table-column align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <el-button style="color:#67C23A;" size="mini" type="text" icon="el-icon-setting" @click="HandleUpdate(scopes.row)">核验</el-button>
          <el-button style="color:#409EFF;" size="mini" type="text" icon="el-icon-view" @click="HandleUpdate(scopes.row)">查看</el-button>
          <el-button style="color:#F56C6C;" icon="el-icon-delete" type="text" size="mini" @click="RowDelete(scopes.row)">删除</el-button>

        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px" style="width: 100%;">
        <el-form-item label="活畜名称" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-input v-model="temp.unit" />
        </el-form-item>
        <el-form-item label="排序" prop="order_no">
          <el-input-number v-model="temp.order_no" :min="1" label="描述文字"></el-input-number>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/baseset/animal' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import dict_data from '@/api/system/dict_data'

export default {
  name: 'Lists',
  components: { Pagination },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'asc', // 默认排序方式,
        sort: 'order_no'
      },
      // 字典参数
      dictionary: []
      // 字典参数
    }
  },
  created() {
    this.loadData()
    dict_data.Drop({ sort: 'sort', order: 'asc', isPaginator: false, dict_code: '' }).then(response => {
      this.dictionary = response.data
    })
  },
  methods: {
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 99999,
        name: '',
        unit: ''
      }
    }

  }
}
</script>
